import React, { useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';
import Slideover from '../../tailwind_common/Slideover';
import { useRingStyle } from '../../tailwind_common/util';
import { InfoCircleIcon } from '../../SVG';
import CareRecSlideoverTitle from '../CareRecommendationSlideoverContent/CareRecSlideoverTitle';
import CareRecSlideoverContent from '../CareRecommendationSlideoverContent/CareRecSlideoverContent';
import './TriageRecommendationeColorMapping';
import TriageRecommendation from './TriageRecommendation';
export var TriageRecommendationWrapper = function (props) {
    var _a = useState(false), isSlideoverOpen = _a[0], setIsSlideoverOpen = _a[1];
    var careRecHeaderRef = useRef(null);
    var theme = props.theme, primaryCareSummary = props.primaryCareSummary, whyThisResultContent = props.whyThisResultContent, conversationId = props.conversationId, bestCareType = props.bestCareType;
    var t = useTranslation().t;
    var ringStyle = useRingStyle();
    useEffect(function () {
        if (careRecHeaderRef.current) {
            var elementTop = careRecHeaderRef.current.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: elementTop - 75,
                behavior: 'smooth',
            });
        }
    }, []);
    return (React.createElement("div", { ref: careRecHeaderRef, className: "flex w-full flex-col items-center" },
        React.createElement("div", { className: "w-3/5 tablet-and-mobile:w-9/10" },
            React.createElement("h2", { className: twMerge('mb-6 flex items-end text-3xl text-gray-800 mobile:mb-4 mobile:text-2xl', 'leading-none') },
                t('common.careRecommendation', 'Care Recommendation'),
                React.createElement("button", { className: twMerge('tw-focus ml-2 flex cursor-pointer items-center rounded-full', 'h-6 w-6 focus:ring-offset-0'), style: ringStyle, onClick: function () { return setIsSlideoverOpen(!isSlideoverOpen); } },
                    React.createElement(InfoCircleIcon, { height: "24", width: "24", pathClassName: "stroke-gray-800" }))),
            React.createElement(TriageRecommendation, { theme: theme, primaryCareSummary: primaryCareSummary, whyThisResultContent: whyThisResultContent, conversationId: conversationId, bestCareType: bestCareType })),
        React.createElement(Slideover, { isOpen: isSlideoverOpen, setIsOpen: setIsSlideoverOpen, Title: React.createElement(CareRecSlideoverTitle, null), Content: React.createElement(CareRecSlideoverContent, null) })));
};
export default TriageRecommendationWrapper;
